import type { ValueOf } from 'routing/constants';
import type { ICourse } from 'modules/api-requests/courses/types';
import type { IGetCurrentUserResponse } from 'modules/api-requests/auth/types';

export enum SystemRolesEnum {
  ADMIN = 'admins',
  SECONDARY_ADMIN = 'secondary-admins',
  MANAGER = 'managers',
  TRADER = 'traders',
  USER = 'users',
}

export type SystemRolesType = ValueOf<SystemRolesEnum>;

export interface IProfileState extends Partial<IGetCurrentUserResponse> {
  groups: SystemRolesType[];
  course?: ICourse;
}

